import NagAlert from "components/NagAlert";
import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useConfigPermission } from "context/useConfigPermission";
import { useOrders } from "context/useOrderData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { PromoItemProps, WebshopId } from "models/WebShop";
import { Link, useParams } from "react-router-dom";
import { isSearchWordsConfigEmpty } from "utility/ProductUtility";
import { UrlPath } from "utility/routes";

const SearchWordsPromo = () => {
  const params = useParams();
  const companyId = params.id ?? "";
  const { companySaleCheck } = useCompanySaleCheck();
  const { productConfigurationsByCompany } = useProductConfiguration();
  const { canConfig } = useConfigPermission();

  if (companyId === "" || companySaleCheck[companyId] === undefined)
    return null;


  const path = `${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.SearchWords}`;

  const showConfig = productConfigurationsByCompany[companyId].searchWords !== undefined && productConfigurationsByCompany[companyId].searchWords !== null && canConfig(companyId);
  const emptySearchwordsConfigNag = isSearchWordsConfigEmpty(productConfigurationsByCompany[companyId].searchWords);

  const nagDescription = "Søkeord er ikke lagt til i bedriftens profil enda. Husk å legge inn relevante søkeord, det hjelper deg å bli funnet!";

  return showConfig ?


  (

    emptySearchwordsConfigNag ? <NagAlert title="Søkeord" shTitle="søkeord" description={nagDescription} path={path} /> :

      <div className="card mt-4">
        <div className="card-header">
          <h2 className="fs-5">Søkeord</h2>
        </div>
        <div className="card-body">
          <p>{productConfigurationsByCompany[companyId].searchWords?.searchWords}</p>
          <div className="mb-0 d-md-flex justify-content-between align-items-center">
            <div>
              <Link
                to={path}
                className="btn btn-primary text-white">Endre søkeord</Link>
            </div>
            <div className="mt-3 mt-md-0">
              <Link
                to={path}
                className="cc-icon-text-link text-muted"><i className="bi bi-box"></i> <span>Kjøpt produkt</span></Link>
            </div>
          </div>
        </div>
      </div>)
      : null
};

export default SearchWordsPromo;